import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { goProtegeFeatures } from '../data/mock';

const ContentSection = () => {
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-block bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-1.5">
                <span className="text-blue-400 text-sm font-semibold uppercase tracking-wider">Guia Completo</span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-extrabold text-gray-900 leading-tight">
                Rastreamento Veicular em Sorocaba: <span className="text-blue-600">Como Escolher a Melhor Empresa</span>
              </h2>

              <div className="space-y-4 text-gray-700 text-base leading-relaxed">
                <p>
                  Quem vive em <strong className="text-gray-900">Sorocaba e região</strong> sabe que a segurança veicular é uma preocupação constante. 
                  Com o crescimento da cidade e o aumento da frota de veículos, o{' '}
                  <strong className="text-gray-900">rastreamento automotivo em Sorocaba</strong> tornou-se uma necessidade para motoristas 
                  e empresas que querem proteger seus ativos e manter o controle total da situação.
                </p>

                <p>
                  Seja para uso pessoal — protegendo seu carro, moto ou caminhonete — ou para{' '}
                  <strong className="text-gray-900">gestão de frotas empresariais em Sorocaba</strong>, escolher a empresa certa de rastreamento 
                  faz toda a diferença. Uma solução eficaz deve oferecer monitoramento em tempo real, bloqueio remoto de emergência, 
                  alertas personalizados e suporte técnico local especializado.
                </p>

                <p>
                  Após análise das opções disponíveis na região, a <strong className="text-blue-600">GoProtege</strong> se destaca como uma das 
                  soluções mais completas e confiáveis para <strong className="text-gray-900">rastreamento veicular em Sorocaba/SP</strong>. 
                  Com atendimento local, tecnologia homologada e equipe treinada, a empresa entrega segurança real com suporte de quem conhece a cidade.
                </p>

                <p>
                  Um bom <strong className="text-gray-900">rastreador com bloqueio em Sorocaba</strong> permite que você, em caso de furto ou roubo, 
                  bloqueie o motor do veículo remotamente pelo aplicativo. Isso aumenta significativamente as chances de recuperação e é um dos 
                  recursos mais valorizados por proprietários de veículos na região.
                </p>
              </div>
            </div>

            {/* Right Content - Features Box */}
            <div className="lg:sticky lg:top-24">
              <div className="bg-[#0a0f1e] border border-blue-500/20 rounded-2xl p-8 shadow-2xl">
                <h3 className="text-2xl lg:text-[26px] font-bold text-white mb-6">O que a GoProtege oferece em Sorocaba</h3>
                
                <div className="space-y-4">
                  {goProtegeFeatures.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300 text-base leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-8 p-6 bg-blue-950/30 border border-blue-500/20 rounded-xl">
                  <p className="text-blue-300 text-sm italic leading-relaxed">
                    "A empresa de rastreamento em Sorocaba que combina tecnologia avançada com atendimento humano e local."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
